import { FormattedMessage } from 'react-intl';

import { HOST_WEB_PRODUCTION, HOST_WEB_STAGING } from 'utils/constants'
import { lawyers } from 'utils/lawyers';
import { shuffle } from 'utils/shuffle';

import Button from 'components/Button';
import Column from 'components/Column';
import ContainerAd from 'components/Container/ContainerAd';
import ContentAd from 'components/Content/ContentAd';
import Footer from 'components/Footer';
import H2 from 'components/H2';
import H3 from 'components/H3';
import P from 'components/P';
import PAd from 'components/P/PAd';
import Thumbnail from 'components/Thumbnail';
import ThumbnailDiv from 'components/Thumbnail/ThumbnailDiv';
import ThumbnailNumber from 'components/Thumbnail/ThumbnailNumber';
import ThumbnailWrapper from 'components/Thumbnail/ThumbnailWrapper';
import { color } from 'components/foundations';

import messages from './messages';

const HOST = process.env.PREACT_APP_API_URL === 'production' ? HOST_WEB_PRODUCTION : HOST_WEB_STAGING;

function onClickCTA(props) {
  const location = props.matches.location;
  const category = props.matches.category;
  const url = props.matches.url;
  const version = props.matches.version;
  const cohort = props.matches.cohort;

  if (!location) return HOST + "/layanan/waris/?utm_source=hukumonline&utm_medium=iframe&utm_campaign=hak_waris&utm_content=uncategorized&category=" + category + "&url=" + url + "&cohort=" + cohort + "&version=" + version
  if (location.includes("summary")) {
    return HOST + "/layanan/waris/?utm_source=hukumonline&utm_medium=iframe&utm_campaign=hak_waris&utm_content=intisari&category=" + category + "&url=" + url + "&cohort=" + cohort + "&version=" + version
  } else if (location === "ulasan-top") {
    return HOST + "/layanan/waris/?utm_source=hukumonline&utm_medium=iframe&utm_campaign=hak_waris&utm_content=ulasan1&category=" + category + "&url=" + url + "&cohort=" + cohort + "&version=" + version
  } else if (location == "ulasan-bottom") {
    return HOST + "/layanan/waris/?utm_source=hukumonline&utm_medium=iframe&utm_campaign=hak_waris&utm_content=ulasan2&category=" + category + "&url=" + url + "&cohort=" + cohort + "&version=" + version
  } else {
    return HOST + "/layanan/waris/?utm_source=hukumonline&utm_medium=iframe&utm_campaign=hak_waris&utm_content=uncategorized&category=" + category + "&url=" + url + "&cohort=" + cohort + "&version=" + version
  }
}

function HeaderTitle(props) {
  return (
    <div>
      <H2 style={{ margin: "0", }}>
        <FormattedMessage {...messages.header} />
      </H2>
      <PAd>
        <FormattedMessage {...messages.description} />
      </PAd>
    </div>
  )
}

function LawyerImage(props) {
  return (
    <ThumbnailWrapper data-testid="summary-lawyer-thumbnail">
      {shuffle(lawyers).slice(0, 3).map((lawyer, index) =>
        <ThumbnailDiv key={'lawyer' + index} zIndex={10 - index}>
          <Thumbnail src={lawyer} alt={'lawyer-' + lawyer.code} />
        </ThumbnailDiv>
      )}
      <ThumbnailDiv zIndex={6}>
        <ThumbnailNumber>60+</ThumbnailNumber>
      </ThumbnailDiv>
    </ThumbnailWrapper>
  )
}

function Price(props) {
  return (
    <div>
      <P style={{ color: color.text_black, margin: "0" }}>{"Cek hak waris via Chat 30 menit"}</P>
      <H3 style={{ fontSize: '20px', margin: '0px', color: "#003366" }}>{"Rp100.000"}</H3>
    </div>
  )
}

const WarisAds = (props) => {
  return (
    <ContainerAd>
      <ContentAd>
        <br />
        <HeaderTitle {...props} />
        <br />
        <LawyerImage {...props} />
        <Price {...props} />
        <Column width="2" style={{ margin: "0" }}>
          <Button
            href={onClickCTA(props)}
            blank="_blank"
            color='yellow'
            size="large"
          >
            <FormattedMessage {...messages.cta} />
          </Button>
        </Column>
        <br />
        <Footer />
      </ContentAd>
    </ContainerAd>
  )
}

export default WarisAds;